/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Unknownlocation2Inputs */

const zh_accountsettings_unknownlocation2 = /** @type {(inputs: Accountsettings_Unknownlocation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未知位置`)
};

const en_accountsettings_unknownlocation2 = /** @type {(inputs: Accountsettings_Unknownlocation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown Location`)
};

const es_accountsettings_unknownlocation2 = /** @type {(inputs: Accountsettings_Unknownlocation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación desconocida`)
};

/**
* | output |
* | --- |
* | "Unknown Location" |
*
* @param {Accountsettings_Unknownlocation2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_unknownlocation2 = /** @type {((inputs?: Accountsettings_Unknownlocation2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Unknownlocation2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_unknownlocation2(inputs)
	if (locale === "en") return en_accountsettings_unknownlocation2(inputs)
	return es_accountsettings_unknownlocation2(inputs)
});
export { accountsettings_unknownlocation2 as "accountSettings_unknownLocation" }